import { transparentize } from "polished";
import React from "react";
import styled from "styled-components";

const Outer = styled.div`
    position: relative;
    height: 116px;
    border-bottom: 1px solid ${transparentize(0.75, "#707070")};
    display: flex;
    justify-content: center;
`;

const Image = styled.img`
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 75%;
    height: 100%;
    padding: 24px;
    object-fit: contain;
    max-width: 300px;
`;

export const CardHeader: React.FC<{
    backgroundColor: string;
    imageUrl: string;
    imageAlt?: string;
}> = props => {
    return (
        <Outer style={{ backgroundColor: props.backgroundColor }}>
            <Image src={props.imageUrl} alt={props.imageAlt} />
        </Outer>
    );
};
